/* global axios */
import ApiClient from './ApiClient';

class LaisXmlFeedAPI extends ApiClient {
  constructor() {
    super('lais/xml_feed', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  validate(payload) {
    return axios.post(`${this.url}/validate`, payload);
  }

  import(payload) {
    return axios.post(`${this.url}/import`, payload);
  }

  history() {
    return axios.get(`${this.url}/history`);
  }

  disable(payload = {}) {
    return axios.post(`${this.url}/disable`, payload);
  }
}

export default new LaisXmlFeedAPI();
